import React from "react";
import { Link } from "react-router-dom";
import { getBrand, PARENT_URL } from "../utils/branding";

export default function Footer() {
  const brand = getBrand();
  
  return (
    <footer style={{
      background: brand.cardBg,
      borderTop: `1px solid ${brand.primary}15`,
      padding: "60px 32px 30px",
      position: "relative",
      zIndex: 2
    }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: "2fr 1fr 1fr 1fr",
          gap: 40,
          marginBottom: 40
        }} className="footer-grid">
          <div>
            <div style={{
              background: brand.gradient,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: 18,
              fontWeight: 800,
              letterSpacing: 3,
              marginBottom: 12
            }}>
              {brand.icon} {brand.name}
            </div>
            <div style={{
              fontSize: 12,
              color: brand.primary,
              letterSpacing: 3,
              marginBottom: 14,
              fontWeight: 600
            }}>
              {brand.tagline}
            </div>
            <p style={{
              fontSize: 13,
              color: brand.textSecondary,
              lineHeight: 1.7,
              maxWidth: 320
            }}>
              Modern security tools for developers and teams. Part of the GetKhojo family.
            </p>
            <div style={{ marginTop: 16 }}>
              <a href="mailto:support@getkhojo.com" style={{
                color: brand.primary,
                textDecoration: "none",
                fontSize: 14,
                fontWeight: 500,
                display: "inline-block",
                padding: "8px 0",
              }}>support@getkhojo.com</a>
            </div>
            <div style={{ marginTop: 20, display: "flex", gap: 26, alignItems: "center" }}>
              <a href="https://x.com/getkhojo" target="_blank" rel="noopener noreferrer" style={{ color: brand.textSecondary, transition: "color 0.2s", display: "inline-flex",
                alignItems: "center", justifyContent: "center", width: 36, height: 36, margin: -9 }} onMouseEnter={e => e.currentTarget.style.color = brand.primary} onMouseLeave={e => e.currentTarget.style.color = brand.textSecondary} aria-label="X (formerly Twitter)">
                <svg style={{ width: 18, height: 18, fill: "currentColor" }} viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://instagram.com/getkhojo" target="_blank" rel="noopener noreferrer" style={{ color: brand.textSecondary, transition: "color 0.2s", display: "inline-flex",
                alignItems: "center", justifyContent: "center", width: 36, height: 36, margin: -9 }} onMouseEnter={e => e.currentTarget.style.color = brand.primary} onMouseLeave={e => e.currentTarget.style.color = brand.textSecondary} aria-label="Instagram">
                <svg style={{ width: 18, height: 18, fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }} viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              </a>
              <a href="https://reddit.com/u/getkhojo" target="_blank" rel="noopener noreferrer" style={{ color: brand.textSecondary, transition: "color 0.2s", display: "inline-flex",
                alignItems: "center", justifyContent: "center", width: 36, height: 36, margin: -9 }} onMouseEnter={e => e.currentTarget.style.color = brand.primary} onMouseLeave={e => e.currentTarget.style.color = brand.textSecondary} aria-label="Reddit">
                <svg style={{ width: 18, height: 18, fill: "currentColor" }} viewBox="0 0 24 24"><path d="M24 11.5c0-1.65-1.35-3-3-3-.96 0-1.86.48-2.42 1.24-1.64-1-3.85-1.64-6.23-1.72l1.3-4.1 4.24.9c.04.98.85 1.78 1.85 1.78 1.02 0 1.86-.84 1.86-1.86S19.96 2.8 18.94 2.8c-.88 0-1.62.62-1.8 1.44l-4.76-1.01a.49.49 0 0 0-.57.34L10.3 8.01c-2.42.06-4.66.7-6.33 1.72-.56-.76-1.47-1.24-2.43-1.24-1.65 0-3 1.35-3 3 0 1.05.54 1.97 1.37 2.51-.06.28-.09.57-.09.87 0 3.71 4.22 6.72 9.4 6.72s9.4-3 9.4-6.72c0-.3-.03-.59-.09-.87.83-.54 1.37-1.46 1.37-2.51zm-17.7 2.1c-.77 0-1.4-.63-1.4-1.4 0-.77.63-1.4 1.4-1.4.77 0 1.4.63 1.4 1.4 0 .77-.63 1.4-1.4 1.4zm10.13 3.65c-.75.75-2.12.82-2.73.82-.6 0-1.98-.07-2.73-.82a.5.5 0 0 1 .71-.71c.42.42 1.34.54 2.02.54.68 0 1.6-.12 2.02-.54a.5.5 0 1 1 .71.71zm-.63-2.25c-.77 0-1.4-.63-1.4-1.4 0-.77.63-1.4 1.4-1.4.77 0 1.4.63 1.4 1.4 0 .77-.63 1.4-1.4 1.4z"/></svg>
              </a>
            </div>
          </div>
          
          <div>
            <div style={{
              fontSize: 12,
              color: brand.primary,
              letterSpacing: 3,
              fontWeight: 700,
              marginBottom: 18
            }}>PRODUCT</div>
            <FooterLink to="/" label="Home" brand={brand} />
            <FooterLink to="/#pricing" label="Pricing" brand={brand} />
            <FooterLink to="/api-docs" label="API Docs" brand={brand} />
            <FooterLink to="/login" label="Sign In" brand={brand} />
            <FooterLink to="/register" label="Sign Up" brand={brand} />
          </div>
          
          <div>
            <div style={{
              fontSize: 12,
              color: brand.primary,
              letterSpacing: 3,
              fontWeight: 700,
              marginBottom: 18
            }}>COMPANY</div>
            <FooterLink to="/about" label="About" brand={brand} />
            <FooterLink to="/blog" label="Blog" brand={brand} />
            <FooterLink to="/contact" label="Contact" brand={brand} />
            <FooterExternal href={PARENT_URL} label="GetKhojo" brand={brand} />
          </div>
          
          <div>
            <div style={{
              fontSize: 12,
              color: brand.primary,
              letterSpacing: 3,
              fontWeight: 700,
              marginBottom: 18
            }}>LEGAL</div>
            <FooterLink to="/privacy" label="Privacy Policy" brand={brand} />
            <FooterLink to="/terms" label="Terms of Service" brand={brand} />
            <FooterLink to="/security" label="Security" brand={brand} />
          </div>
        </div>
        
        <div style={{
          borderTop: `1px solid ${brand.primary}15`,
          paddingTop: 24,
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 12,
          fontSize: 12,
          color: brand.textMuted
        }}>
          <div>© 2026 {brand.name} · All rights reserved</div>
          <div>Part of <a href={PARENT_URL} style={{
            color: brand.primary,
            textDecoration: "none",
            fontWeight: 700,
            letterSpacing: 1
          }}>GETKHOJO</a></div>
        </div>
      </div>
      
      <style>{`
        @media (max-width: 768px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
        }
      `}</style>
    </footer>
  );
}

function FooterLink({ to, label, brand }) {
  return (
    <Link to={to} style={{
      display: "block",
      color: brand.textSecondary,
      textDecoration: "none",
      fontSize: 14,
      padding: "9px 0",
      marginBottom: 2,
      transition: "color 0.2s"
    }}
    onMouseEnter={e => e.target.style.color = brand.primary}
    onMouseLeave={e => e.target.style.color = brand.textSecondary}>
      {label}
    </Link>
  );
}

function FooterExternal({ href, label, brand }) {
  return (
    <a href={href} style={{
      display: "block",
      color: brand.textSecondary,
      textDecoration: "none",
      fontSize: 14,
      padding: "9px 0",
      marginBottom: 2,
      transition: "color 0.2s"
    }}
    onMouseEnter={e => e.target.style.color = brand.primary}
    onMouseLeave={e => e.target.style.color = brand.textSecondary}>
      {label}
    </a>
  );
}
